import { Module } from 'vuex'
import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'
import { NoteModel } from '@/models/interfaces/note.model'
import { NotesState } from '@/store/modules/notes/types'

const state: NotesState = {
  notes: [] as NoteModel[],
  loading: false
}

export const notes: Module<NotesState, any> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
